/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Finish_FinalistInputs */



/**
* | output |
* | --- |
* | "Finalist" |
*
* @param {Meta_Finish_FinalistInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_finish_finalist = /** @type {((inputs?: Meta_Finish_FinalistInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Finish_FinalistInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Finalist")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finaliste")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("亚军")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("亞軍")
	if (locale === "ko") return /** @type {LocalizedString} */ ("준우승")
	return /** @type {LocalizedString} */ ("Finalist")
});